// import React from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { setCurrentPage } from "../redux/navigationSlice.js";
// export function CallToAction({ onNavigate }) {
//   const data = useSelector((state) => state.user);
//   console.log(data, "data-----");
//   const userid = data?.userId?.user?._id;
//   console.log("userid", userid);
//   const token = data?.userId?.accessToken;
//   const dispatch = useDispatch();
//   return (
//     <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-red-500 to-pink-600 text-white">
//       <div className="max-w-4xl mx-auto text-center">
//         <h2 className="text-3xl md:text-4xl mb-4">
//           Looking for Your Perfect Match?
//         </h2>
//         <p className="text-xl mb-8 text-red-100">
//           Join countless couples who began their love story through AvanAval
//         </p>
//         <div className="flex flex-col sm:flex-row gap-4 justify-center">
//           {!token && (
//             <button
//               onClick={() => onNavigate && onNavigate("login")}
//               className="bg-white text-red-600 px-8 py-3 rounded-lg hover:bg-red-50 transition-colors cursor-pointer"
//             >
//               Create Free Profile
//             </button>
//           )}
//           <button
//             onClick={() => {
//               dispatch(setCurrentPage("subscription"));
//             }}
//             className="border-2 border-white text-white px-8 py-3 rounded-lg hover:bg-white hover:text-red-600 transition-colors cursor-pointer">
//             View Success Stories
//           </button>
//         </div>
//       </div>
//     </section>
//   );
// }
"use client";

import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPage } from "../redux/navigationSlice.js";
import { useTranslation } from "react-i18next";

// ⭐ Import AOS
import AOS from "aos";
import "aos/dist/aos.css";

export function CallToAction({ onNavigate }) {
  const data = useSelector((state) => state.user);
  const token = data?.userId?.accessToken;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // ⭐ Initialize AOS
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
    AOS.refresh();
  }, []);

  return (
    <section
      className="py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-red-500 to-pink-600 text-white"
      data-aos="fade-up"
    >
      <div className="max-w-4xl mx-auto text-center">

        <h2
          className="text-3xl md:text-4xl mb-4"
          data-aos="fade-down"
          data-aos-delay="200"
        >
          {t("Looking for Your Perfect Match?")}
        </h2>

        <p
          className="text-xl mb-8 text-red-100"
          data-aos="fade-up"
          data-aos-delay="400"
        >
          {t("Join countless couples who began their love story through AvanAval")}
        </p>

        <div
          className="flex flex-col sm:flex-row gap-4 justify-center"
          data-aos="zoom-in"
          data-aos-delay="600"
        >
          {!token && (
            <button
              onClick={() => navigate('/login')}
              className="bg-white text-red-600 px-8 py-3 rounded-lg hover:bg-red-50 transition-colors cursor-pointer"
            >
              {t("Create Free Profile")}
            </button>
          )}

          <button
            onClick={() => navigate('/subscription')}
            className="border-2 border-white text-white px-8 py-3 rounded-lg hover:bg-white hover:text-red-600 transition-colors cursor-pointer"
          >
            {t("Get Premium Today")}
          </button>
        </div>
      </div>
    </section>
  );
}
